import intl from "react-intl-universal";
import styles from "./index.module.scss";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { DownOutlined } from "@ant-design/icons";
let primaryRoute = [
  // {
  // 	title: "Home",
  // 	link: "/",
  // },

  {
    title: "Discover",
    link: "discover",
    children: [
      {
        type: "Community Resources",
        all: {
          type: "All Resource",
          title: "All Resource",
          link: "/discover/open-datasets?type=All&title=All",
          data: [],
        },
        data: [
          {
            title: "Open Data",
            link: "/open-datasets?type=OpenGeospatialData&title=OpenData",
            children: [
              {
                title: "Open Geospatial Data",
                link: "/open-datasets?type=OpenGeospatialData&title=OpenData",
              },
              {
                title: "Open AI Training Data",
                link: "/open-datasets?type=OpenAITrainingData&title=OpenData",
              },
              {
                title: "Open Data Services",
                link: "/open-datasets?type=OpenDataServices&title=OpenData",
              },
            ],
          },
          {
            title: "Open Tools",
            link: "/open-datasets?type=OpenCodes&title=OpenTools",
            children: [
              {
                title: "Open Codes",
                link: "/open-datasets?type=OpenCodes&title=OpenTools",
              },
              {
                title: "Open Executables",
                link: "/open-datasets?type=OpenExecutables&title=OpenTools",
              },
              {
                title: "Open SDKs",
                link: "/open-datasets?type=OpenSDKs&title=OpenTools",
              },
              {
                title: "Open Container Images",
                link: "/open-datasets?type=OpenContainerImages&title=OpenTools",
              },
              {
                title: "Open Process Services",
                link: "/open-datasets?type=OpenProcessServices&title=OpenTools",
              },
            ],
          },
          {
            title: "Open Docs",
            link: "/open-datasets?type=OpenSpecifications&title=OpenDocs",
            children: [
              {
                title: "Specifications Docs",
                link: "/open-datasets?type=OpenSpecifications&title=OpenDocs",
              },
              {
                title: "Technical Docs",
                link: "/open-datasets?type=TechnicalDocs&title=OpenDocs",
              },
              {
                title: "Development Guidelines",
                link: "/open-datasets?type=DevelopmentGuidelines&title=OpenDocs",
              },
              {
                title: "Training & Course Materials",
                link: "/open-datasets?type=TrainingCourseMaterials&title=OpenDocs",
              },
            ],
          },
          {
            title: "Open Apps",
            link: "/open-datasets?type=OpenWebApps&title=OpenApps",
            children: [
              {
                title: "Open Web Apps",
                link: "/open-datasets?type=OpenWebApps&title=OpenApps",
              },
            ],
          },
          {
            title: "Open Skills",
            link: "/skillhub",
            children: [
              {
                title: "Open Skill Hub",
                link: "/skillhub",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: "Infrastructure",
    link: "infrastructure",
    children: [
      // {
      //   title: "OGE Develop Center",
      //   link: "/developCenter",
      // },
      {
        type: "OGE Develop Center",
        data: [
          {
            title: "OGE Develop Center",
            link: "https://www.openge.org.cn/develop",
          },
        ],
      },
      {
        type: "OGE Resources",
        data: [
          {
            title: "Datasets",
            link: "https://www.openge.org.cn/dataset",
          },
          {
            title: "Models & Tools",
            link: "https://www.openge.org.cn/models",
          },
          {
            title: "Applications",
            link: "https://www.openge.org.cn/toolbox",
          },
        ],
      },
      {
        type: "Geospatial Agent",
        data: [
          {
            title: "OpenGA",
            link: `/infrastructure/openGA`,
          },
        ],
      },
    ],
  },
  {
    title: "Community",
    link: "community",
    children: [
      {
        title: "Competitions",
        link: "/match-center",
      },
      {
        title: "How to share",
        link: "/how-to-share",
      },
      {
        title: "News",
        link: "/news",
      },
      {
        title: "Events",
        link: "/events",
      },
    ],
  },
  {
    title: "About",
    link: "about",
    children: [
      {
        title: "About OpenGA",
        link: "/openga",
      },
      {
        title: "Who We Are",
        link: "/who-we-are",
      },
      // {
      //   title: "Member Listing",
      //   link: "/member-listing",
      // },
      {
        title: "Contact Us",
        link: "/contact-us",
      },
    ],
  },
  // {
  //   title: "Information",
  //   link: "/blog-news",
  //   children: [
  //     {
  //       title: "Blog",
  //       link: "/blog",
  //     },
  //     {
  //       title: "News",
  //       link: "/news",
  //     },
  //     {
  //       title: "Events",
  //       link: "/events",
  //     },
  //   ],
  // },
];
const MenuBar = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.user);
  const roleId = useMemo(() => userInfo?.roleId, [userInfo]);
  let routes = useMemo(() => {
    let route = JSON.parse(JSON.stringify(primaryRoute));
    if (Number(roleId) === 1) {
      const arr = route.concat([
        {
          title: "Management Center",
          link: "administration",
          children: [
            {
              title: "Data auditing",
              link: "/data-auditing",
            },
            {
              title: "Open Skill Hub auditing",
              link: "/skillhub-auditing",
            },
            {
              title: "Comment auditing",
              link: "/comment-auditing",
            },
            {
              title: "Tags management",
              link: "/tags-manage",
            },
            {
              title: "Data statistics",
              link: "/data-statistics",
            },
            {
              title: "News management",
              link: "/news",
            },
            {
              title: "Events management",
              link: "/events",
            },
            {
              title: "User management",
              link: "/user",
            },
            {
              title: "Material management",
              link: "/material",
            },
          ],
        },
      ]);
      return arr;
    } else {
      return route;
    }
  }, [roleId]);

  const router = useLocation();
  const pathName = useMemo(() => {
    const arr = router.pathname?.split("/");
    return "/" + arr[1];
  }, [router]);

  const isFirstMenuActive = (route) => {
    const normalizedRouteLink = route.link.startsWith("/") ? route.link : `/${route.link}`;
    if (route.link === "discover" && pathName === "/skillhub") return true;
    return pathName === normalizedRouteLink;
  };

  const getMenuTargetPath = (first, link) => {
    if (!link || link.includes("http")) return "";
    if (link.startsWith(`/${first}`) || link === "/skillhub" || link.startsWith("/skillhub/")) return link;
    const resolvedLink = resolveMenuLink(first, link);
    return resolvedLink.startsWith("/") ? resolvedLink : `/${resolvedLink}`;
  };

  const isMenuLinkActive = (first, link) => {
    return getMenuTargetPath(first, link) === router.pathname + router.search;
  };

  const resolveMenuLink = (first, link) => {
    if (link === "/skillhub" || link.startsWith("/skillhub/")) return link;
    return `/${first}${link}`;
  };

  // 一级路由跳转方法
  const handleLinkChange = (route) => {
    if (route.children) return;
    navigate(route.link);
    window.scrollTo(0, 0);
  };

  // 二级、三级路由跳转方法
  const handleLinkChangeScond = (first, second) => {
    if (second.includes("http")) {
      window.open(second, "_blank");
    } else {
      navigate(resolveMenuLink(first, second));
      window.scrollTo(0, 0);
    }
  };

  const linkToOut = (type, url) => {
    if (
      type !== "Course Hub" &&
      type !== "Open Skill Hub" &&
      type !== "OpenGA"
    ) {
      window.open(url, "_blank");
    } else {
      navigate(url);
      window.scrollTo(0, 0);
    }
  };

  return (
    <div className={classNames("flex_box", "flex_between", "align_center", styles.menuBox)}>
      {routes.map((item) => {
        return (
          <div key={item.link} onClick={() => handleLinkChange(item)}>
            <div
              className={classNames(
                styles.firstMenu,
                isFirstMenuActive(item) && styles.active,
                "flex_box",
              )}
            >
              {intl.get(`Header.${item.title}`)}{" "}
              {item.children && (
                <DownOutlined
                  className={classNames(styles.expandIcon)}
                  style={{ fontSize: "12px" }}
                />
              )}
            </div>
            {item.children && (
              <div
                className={classNames(
                  styles.secondMenu,
                  item.link === "discover" && styles.bigLeft,
                  item.link === "infrastructure" && styles.secondLeft,
                )}
              >
                <div className={styles.intervalBox}></div>
                <div className={styles.routerBox}>
                  {item.link !== "discover" &&
                    item.link !== "infrastructure" &&
                    item.children.map((second) => (
                      <div
                        onClick={() => handleLinkChangeScond(item.link, second.link)}
                        key={second.link}
                        className={classNames(
                          styles.linkBox,
                          isMenuLinkActive(item.link, second.link) && styles.active,
                        )}
                      >
                        {intl.get(`Header.${second.title}`)}
                        {/*second.title*/}
                      </div>
                    ))}
                  {(item.link === "discover" || item.link === "infrastructure") &&
                    item.children.map((second) => (
                      <div key={second.type} className={styles.discoverBox}>
                        <p>
                          {intl.get(`Header.${second.type}`)}{" "}
                          {second.all ? (
                            <a href={second.all.link} className={styles.discoverAll}>
                              {intl.get(`Header.${second.all.title}`)}→
                            </a>
                          ) : (
                            ""
                          )}{" "}
                        </p>
                        <div className={classNames("flex_box")}>
                          {second.data.map((thrid) => (
                            <div key={thrid.title}>
                              {thrid.children ? (
                                <p className={styles.thirdTitle}>
                                  {intl.get(`Header.${thrid.title}`)}
                                </p>
                              ) : (
                                <p
                                  onClick={() => linkToOut(thrid.title, thrid.link)}
                                  className={classNames(
                                    styles.noChild,
                                    isMenuLinkActive(item.link, thrid.link) &&
                                      styles.menuItemActive,
                                  )}
                                >
                                  {intl.get(`Header.${thrid.title}`)}
                                </p>
                              )}
                              {thrid.children &&
                                thrid.children.map((fourth) => (
                                  <div
                                    key={fourth.title}
                                    className={classNames(
                                      styles.linkBox,
                                      isMenuLinkActive(item.link, fourth.link) && styles.active,
                                    )}
                                    onClick={() => handleLinkChangeScond(item.link, fourth.link)}
                                  >
                                    {intl.get(`Header.${fourth.title}`)}
                                  </div>
                                ))}
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MenuBar;
